import React from "react";

export interface TextAreaInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  isDisabled?: boolean;
  isSummary?: boolean;
  onKeyUp?: React.KeyboardEventHandler<HTMLTextAreaElement> | null;
  placeholder?: string;
  maxLength?: number | null;
  textAreaHeight?: number | string | undefined;
}

export default function TextAreaInput({
  value,
  onChange,
  isDisabled = false,
  isSummary = false,
  onKeyUp = null,
  placeholder = "",
  maxLength = null,
  textAreaHeight = undefined,
}: TextAreaInputProps) {
  return (
    <textarea
      style={{
        ...(isSummary && {
          width: `calc(${(value[0] || "").length}ch + 60px)`,
          background: "transparent",
        }),
        height: textAreaHeight,
      }}
      disabled={isDisabled || isSummary}
      className="form-control"
      value={value[0] ?? ""}
      onChange={(e) => onChange([e.target.value])}
      onKeyUp={onKeyUp ?? undefined}
      placeholder={placeholder}
      maxLength={maxLength ?? undefined}
    />
  );
}
